import React, { Fragment, useState } from "react";
import { MotorizationListItem } from "@App/Components/Vehicletree/MotorizationList/MotorizationListItem";
import { FuelType, Motorization } from "@App/types";
import { useVehicletree } from "@App/hooks/api/useVehicletree";
import { Checkbox } from "@App/Components/common/Checkbox";
import { MotorizationListSkeleton } from "@App/Components/Vehicletree/MotorizationList/MotorizationListSkeleton";
import { useTranslation } from "react-i18next";

type MotorizationListProps = {
  onClick: (motorization: Motorization) => void;
};

export const MotorizationList = React.memo<MotorizationListProps>(
  (props: MotorizationListProps) => {
    const { t } = useTranslation();

    const { loading, motorizations, error } = useVehicletree();

    const [fuelTypes, setFuelTypes] = useState([]);

    const setFuelType = (fuelType: FuelType, checked: boolean) => {
      if (checked) {
        setFuelTypes([...fuelTypes, fuelType]);
      } else {
        setFuelTypes(fuelTypes.filter((ft) => ft.id !== fuelType.id));
      }
    };

    const getMotorizations = () => {
      // if no fueltype filter is set, show all motorizations
      // else show only motorizations with the selected fueltypes
      const filteredMotorizations =
        motorizations &&
        motorizations.filter((motorization) =>
          fuelTypes.length > 0 ? fuelTypes.includes(motorization.fuelType) : true,
        );

      return (
        filteredMotorizations &&
        filteredMotorizations.map((motor, id) => (
          <MotorizationListItem key={id} motorization={motor} onClick={props.onClick} />
        ))
      );
    };

    const onlyUnique = (value, index, self) => {
      return self.indexOf(value) === index;
    };

    const getFuelTypes = () => {
      return (
        motorizations &&
        motorizations
          .map((motor) => motor.fuelType)
          .filter(onlyUnique)
          .map((fuelType) => (
            <Checkbox
              title={fuelType.name}
              key={fuelType.id}
              status={fuelTypes.includes(fuelType)}
              onChange={(checked) => setFuelType(fuelType, checked)}
            />
          ))
      );
    };

    if (loading) {
      return <MotorizationListSkeleton />;
    }

    if (error) {
      return <div>Error</div>;
    }

    return (
      <Fragment>
        <div className="mt-5">
          <div className="font-weight-bold">{t("motorizationList.fuel-type")}</div>
          <div
            className="
                        w-full md:w-1/3
                        grid grid-cols-2 gap-4
                        mt-4 mb-6"
          >
            {getFuelTypes()}
          </div>
        </div>
        {getMotorizations()}
      </Fragment>
    );
  },
);
